import type { Role, SalespersonTier } from './types';

export type Permission =
  | 'vehicles:read' | 'vehicles:write' | 'vehicles:delete'
  | 'stock:write' | 'stock:import' | 'reservations:write' | 'reservations:delete' | 'reservations:export' | 'customers:write' | 'customers:delete'
  | 'sales:write' | 'stats:read' | 'audit:read' | 'employees:write' | 'settings:write' | 'provider:sync' | 'newsletter:read';

const permissions: Record<Role, ReadonlySet<Permission>> = {
  ADMIN: new Set(['vehicles:read', 'vehicles:write', 'vehicles:delete', 'stock:write', 'stock:import', 'reservations:write', 'reservations:delete', 'reservations:export', 'customers:write', 'customers:delete', 'sales:write', 'stats:read', 'audit:read', 'employees:write', 'settings:write', 'provider:sync', 'newsletter:read']),
  MANAGER: new Set(['vehicles:read', 'vehicles:write', 'stock:write', 'reservations:write', 'customers:write', 'sales:write', 'stats:read', 'provider:sync']),
  SALESPERSON: new Set(['vehicles:read', 'reservations:write', 'customers:write', 'sales:write']),
};

export const can = (role: Role, permission: Permission, commissionTier?: SalespersonTier | null) =>
  permissions[role].has(permission)
  || (role === 'SALESPERSON' && commissionTier === 'TIER_3' && permission === 'provider:sync');
